module.exports = __webpack_public_path__ + "static/media/cableado.01a8db05.png";